<ng-container
  *ngIf="isAdminRoute; then adminLayout; else pervalLayout"
></ng-container>

<ng-template #adminLayout>
  <!-- Inclure le layout pour l'administration -->
  <admin-layout></admin-layout>
</ng-template>

<ng-template #pervalLayout>
  <!-- Inclure le layout pour l'application Perval -->
  <app-container></app-container>
</ng-template>
